import {
  GENDER_FEMALE,
  GENDER_NON_BINARY,
  GENDER_TRANS_FEMALE,
  GENDER_TRANS_MALE,
  UK_ETHNICITY_TYPE,
  US_ETHNICITY_TYPE,
} from './demographicConstants';
import { GENDER_MALE } from './demographicConstants';

const US_ROLE_TYPES = {
  BG: 'Background',
  FBG: 'Featured Background',
  STAND_IN: 'Stand-in',
  PHOTO_DOUBLE: 'Photo Double',
  SPECIAL_ABILITY: 'Special Ability',
} as const;

export const US_ROLE_TYPE_VALUE_TO_LABEL = {
  [US_ROLE_TYPES.BG]: 'Background',
  [US_ROLE_TYPES.FBG]: 'Featured BG',
  [US_ROLE_TYPES.STAND_IN]: 'Stand In',
  [US_ROLE_TYPES.PHOTO_DOUBLE]: 'Photo Double',
  [US_ROLE_TYPES.SPECIAL_ABILITY]: 'Special Ability',
};

export const US_ROLE_TYPE_OPTIONS = [
  {
    label: US_ROLE_TYPE_VALUE_TO_LABEL[US_ROLE_TYPES.BG],
    value: US_ROLE_TYPES.BG,
  },
  {
    label: US_ROLE_TYPE_VALUE_TO_LABEL[US_ROLE_TYPES.STAND_IN],
    value: US_ROLE_TYPES.STAND_IN,
  },
  {
    label: US_ROLE_TYPE_VALUE_TO_LABEL[US_ROLE_TYPES.FBG],
    value: US_ROLE_TYPES.FBG,
  },
  {
    label: US_ROLE_TYPE_VALUE_TO_LABEL[US_ROLE_TYPES.PHOTO_DOUBLE],
    value: US_ROLE_TYPES.PHOTO_DOUBLE,
  },
  {
    label: US_ROLE_TYPE_VALUE_TO_LABEL[US_ROLE_TYPES.SPECIAL_ABILITY],
    value: US_ROLE_TYPES.SPECIAL_ABILITY,
  },
];

export const US_ROLE_TYPE_OPTION_VALUES = US_ROLE_TYPE_OPTIONS.map(
  (option) => option.value
);

export const UK_ROLE_TYPES = {
  BA: 'Background Artist',
  BD: 'Body Double',
  D: 'Double',
  FA: 'Featured Artist',
  PD: 'Picture Double',
  SPACT: 'SPACT Performer',
  SI: 'Stand In',
  SAs: 'Supporting Artist',
  WO: 'Walk On Artist',
} as const;

export const UK_ROLE_TYPE_VALUE_TO_LABEL = {
  [UK_ROLE_TYPES.BA]: 'Background Artist',
  [UK_ROLE_TYPES.BD]: 'Body Double',
  [UK_ROLE_TYPES.D]: 'Double',
  [UK_ROLE_TYPES.FA]: 'Featured Artist',
  [UK_ROLE_TYPES.PD]: 'Picture Double',
  [UK_ROLE_TYPES.SPACT]: 'SPACT Performer',
  [UK_ROLE_TYPES.SI]: 'Stand In',
  [UK_ROLE_TYPES.SAs]: 'Supporting Artist',
  [UK_ROLE_TYPES.WO]: 'Walk On Artist',
};

export const UK_ROLE_TYPE_OPTIONS = [
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.BA],
    value: UK_ROLE_TYPES.BA,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.BD],
    value: UK_ROLE_TYPES.BD,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.D],
    value: UK_ROLE_TYPES.D,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.FA],
    value: UK_ROLE_TYPES.FA,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.PD],
    value: UK_ROLE_TYPES.PD,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.SPACT],
    value: UK_ROLE_TYPES.SPACT,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.SI],
    value: UK_ROLE_TYPES.SI,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.SAs],
    value: UK_ROLE_TYPES.SAs,
  },
  {
    label: UK_ROLE_TYPE_VALUE_TO_LABEL[UK_ROLE_TYPES.WO],
    value: UK_ROLE_TYPES.WO,
  },
];

export const UK_ROLE_TYPE_OPTION_VALUES = UK_ROLE_TYPE_OPTIONS.map(
  (option) => option.value
);

export const UNION_STATUS_TYPE = {
  SAG_AFTRA: 'SAG-AFTRA',
  NON_UNION: 'Non-Union',
  SAG_AFTRA_NON_UNION: 'SAG-AFTRA / Non-Union',
} as const;

export const UNION_STATUS_OPTIONS = [
  {
    label: UNION_STATUS_TYPE.SAG_AFTRA,
    value: UNION_STATUS_TYPE.SAG_AFTRA,
  },
  {
    label: UNION_STATUS_TYPE.NON_UNION,
    value: UNION_STATUS_TYPE.NON_UNION,
  },
];

export const UNION_STATUS_OPTION_VALUES = UNION_STATUS_OPTIONS.map(
  (option) => option.value
);

export type JobPostStatusType = 'open' | 'submitted' | 'closed';
const JOB_POST_STATUS_TYPE: Record<string, JobPostStatusType> = {
  OPEN: 'open',
  SUBMITTED: 'submitted',
  CLOSED: 'closed',
};

export const JOB_POST_STATUS_OPTIONS = [
  {
    label: 'Open',
    value: JOB_POST_STATUS_TYPE.OPEN,
  },
  {
    label: 'Submitted',
    value: JOB_POST_STATUS_TYPE.SUBMITTED,
  },
  {
    label: 'Closed',
    value: JOB_POST_STATUS_TYPE.CLOSED,
  },
];

export const JOB_POST_STATUS_OPTION_VALUES = JOB_POST_STATUS_OPTIONS.map(
  (option) => option.value
);

const APPLICATION_GENDER_TYPE = {
  MALE: GENDER_MALE,
  FEMALE: GENDER_FEMALE,
  TRANS_MALE: GENDER_TRANS_MALE,
  TRANS_FEMALE: GENDER_TRANS_FEMALE,
  NON_BINARY: GENDER_NON_BINARY,
};

export const APPLICATION_GENDER_OPTIONS = [
  {
    label: 'Male',
    value: APPLICATION_GENDER_TYPE.MALE,
  },
  {
    label: 'Female',
    value: APPLICATION_GENDER_TYPE.FEMALE,
  },
  {
    label: 'Trans Male',
    value: APPLICATION_GENDER_TYPE.TRANS_MALE,
  },
  {
    label: 'Trans Female',
    value: APPLICATION_GENDER_TYPE.TRANS_FEMALE,
  },
  {
    label: 'Non-Binary',
    value: APPLICATION_GENDER_TYPE.NON_BINARY,
  },
];

export const APPLICATION_GENDER_OPTION_VALUES = APPLICATION_GENDER_OPTIONS.map(
  (option) => option.value
);

export const US_ETHNICITY_OPTIONS: US_ETHNICITY_TYPE[] = [
  'East Asian',
  'Southeast Asian',
  'South Asian / East Indian',
  'Caucasian',
  'Eastern European',
  'Mediterranean',
  'Middle Eastern',
  'African American',
  'African Descent',
  'Caribbean / West Indies',
  'Pacific Islander / Hawaiian',
  'Native American / Alaskan',
  'South American',
  'Hispanic / Latinx',
  'Ethnically Ambiguous',
];

export const UK_ETHNICITY_OPTIONS: UK_ETHNICITY_TYPE[] = [
  'African - Central',
  'African - Eastern',
  'African - Southern',
  'African - Western',
  'North African',
  'Afro Caribbean / West Indies',
  'Australasia',
  'Pacific Islander / Hawaiian',
  'Central Asia',
  'East Asian',
  'South Asian / East Indian',
  'Eastern European',
  'Northern European',
  'Mediterranean',
  'Scandinavian',
  'Middle Eastern',
  'North American',
  'South American',
  'Latin American',
  'Mixed Race',
];
